/* estados de la aplicacion author */
const state = {
  isLoggedIn: !!localStorage.getItem('token'),
  dataUser: null,
}

export default state
